import React from 'react'
import { Box, Text, HStack } from '@chakra-ui/react'
import { Button } from '@chakra-ui/react'
import { Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { PAGE_SIZES, PageSizeType } from '~config/constants'

interface Props {
    size: number
    setSize: (size: PageSizeType) => void
    total?: number
    /** More results exist past `total`; shown as "100+". */
    isTotalCapped?: boolean
}

const PageSizeSelect: React.FC<Props> = ({
    size,
    setSize,
    total,
    isTotalCapped = false,
}) => {
    const isSelected = (sizeVal: number) => sizeVal === size

    return (
        <HStack alignItems="center">
            <Text fontSize="sm" fontWeight="semibold" lineHeight={2}>
                Show
            </Text>
            <Menu>
                <MenuButton
                    size="xs"
                    variant="outline"
                    as={Button}
                    rightIcon={<ChevronDownIcon />}
                >
                    {size}
                </MenuButton>
                <MenuList>
                    {PAGE_SIZES.map(sizeVal => (
                        <MenuItem
                            key={sizeVal}
                            onClick={() => setSize(sizeVal)}
                            color={
                                isSelected(sizeVal) ? 'gray.900' : 'gray.700'
                            }
                            fontWeight={isSelected(sizeVal) ? 'bold' : 'normal'}
                        >
                            <Text>{sizeVal}</Text>
                        </MenuItem>
                    ))}
                </MenuList>
            </Menu>
            <Text fontSize="sm" fontWeight="semibold" lineHeight={2}>
                per page{' '}
                {!!total && `(${total}${isTotalCapped ? '+' : ''} total)`}
            </Text>
        </HStack>
    )
}

export default PageSizeSelect
